

























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { v1 } from 'uuid'
import LivePlayer from './components/LivePlayer.vue'
import AuthorInfo from './components/AuthorInfo.vue'
import TalkAreaWithCar from './components/TalkAreaWithCarV1.vue'
import Replay from './components/Replay.vue'
import { getRoomInfo } from '@/api/ZnPlayer'
import { liveRoomTypeenum } from '@/common/enums'
import { getUserInfo } from 'apiUtils/Login'
import { getTimeGap } from '../../utils/index'
import { saveLiveRoomUpShare } from '@/api/Anchor'
import { addUpHeaters, postMessage } from './utils'

import { now } from 'moment';

enum selfTypeEnum {
 GOOD_MSG = 6, // 商品上下架
}

@Component({
  components: {
    LivePlayer,
    AuthorInfo,
    Replay,
    TalkAreaWithCar,
  },
})
export default class ZnPlayer extends Vue {
  private sid!: string
  private roomId!: string
  private userId!: string
  private userName = '游客'
  private userImg = 'http://hrmsv3-mlearning-stg5.pingan.com.cn:20083/learn/app/default1'
  private loading = false
  private needAuth = false
  private clickTime = 0
  private status = 0
  private created () {
    getTimeGap()
    this.loading = true
    this.getRoomDetail()
    this.getLoginInfo()
  }

   private async getRoomDetail () {
    const { roomId } = this.$route.query
    const res: any = await getRoomInfo(roomId as string, this.sid)
    if (+res.code === 0) {
      this.status = res.body.status
      document.title = res.body.roomName || '知鸟直播'
      this.$store.dispatch('updateLiveRoomInfo', {
        giftCount: res.body.giftCount || 0,
        upCount: res.body.upCount || 0,
        nowPerson: res.body.nowCount || 0, // 当前在线人数
        personTotal: res.body.nowCount || 0,
      })
      // 回放状态，从 roomInfo内取得主播信息
      if (this.status === 3) {
        const nowAnchor = this.$store.state.currentAuthor
        this.$store.dispatch('updateCurrentAuthor', {
          ...nowAnchor,
          anchorName: res.body.anchorName,
          anchorOrgName: res.body.anchorOrgName,
          anchorPhoto: res.body.anchorPhoto
        })
      }
    }
    console.log('this.loading:', this.status)
  }

  private getLoginInfo () {
    const { sid, roomId, userId, appId } = this.$route.query
    if (sid) {
      this.needAuth = true
      this.sid = sid as string
      this.roomId = roomId as string
      this.userId = userId as string
      this.getUserInfo()
    } else {
      this.sid = `$ZNYOUKE@${v1().replace(/-/g, '').slice(0, 23).toUpperCase()}`
      this.userId = `$ZNYOUKE@${v1().replace(/-/g, '').slice(0, 20).toUpperCase()}uid`
      this.roomId = this.$route.query.roomId as string
      this.$store.dispatch('updateUserInfo', {
        userName: this.userName,
        userImg: this.userImg,
        userId: this.userId,
        isTourist: true
      })
    }
    if (appId) {
      this.$store.dispatch('setAppId', appId)
    }
    this.$store.dispatch('setSid', this.sid)
    this.loading = false
  }

  private async getUserInfo () {
    this.loading = true
    const resp = await getUserInfo({
      sid: this.sid,
      nonGzip: 1
    })
    this.loading = false
    if (+resp.code === 0) {
      const { userName,
              userImg = 'http://hrmsv3-mlearning-stg5.pingan.com.cn:20083/learn/app/default1',
            } = resp.body;
      this.userName = userName
      this.userImg = userImg
       this.$store.dispatch('updateUserInfo', {
        userName: this.userName,
        userImg: this.userImg,
        userId: this.userId,
      })
    }
  }

  private saveLiveRoomUpShare () {
    const nowTime = Date.now()
    if (this.clickTime && nowTime - this.clickTime < 300) {
      this.clickTime = 0
      addUpHeaters(this)
      saveLiveRoomUpShare(this.roomId, this.$store.state.sid)
    }
    this.clickTime = Date.now()
  }

  private get isLiveStream () {
    return (this.$route.params.liveRoomType || '1') as string === liveRoomTypeenum.LIVEING
  }

  private carAction (productData) {
    const { functionType, content } = JSON.parse(productData.Content)
    if (functionType === selfTypeEnum.GOOD_MSG) {
      postMessage({
        productId: content.productId,
        roomId: this.$route.query.roomId,
        productStatus: content.productStatus
      })
    }
  }
}
